// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-inner {
  width: 100px;
  height: 60px;
  margin: auto;
  position: absolute;
  inset: 0;
}
.loader{
  height: 250px;
  position: relative;
}

.loader-line-wrap {
  animation: spin 2000ms cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;
  width: 100px;
  height: 3.5rem;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  transform-origin: 50% 100%;
}

.loader-line {
  border: 4px solid transparent;
  border-radius: 100%;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  position: absolute;
  inset: 0;
}

.loader-line-wrap:nth-child(1) {
  animation-delay: -50ms;
}

.loader-line-wrap:nth-child(2) {
  animation-delay: -100ms;
}

.loader-line-wrap:nth-child(3) {
  animation-delay: -150ms;
}

.loader-line-wrap:nth-child(4) {
  animation-delay: -200ms;
}

.loader-line-wrap:nth-child(5) {
  animation-delay: -250ms;
}

.loader-line-wrap:nth-child(1) .loader-line {
  border-color: #fed700;
  height: 90px;
  width: 90px;
  top: 7px;
}

.loader-line-wrap:nth-child(2) .loader-line {
  border-color: #fe7e00;
  height: 76px;
  width: 76px;
  top: 14px;
}

.loader-line-wrap:nth-child(3) .loader-line {
  border-color: #dc3731;
  height: 62px;
  width: 62px;
  top: 21px;
}

.loader-line-wrap:nth-child(4) .loader-line {
  border-color: #01d1a0;
  height: 48px;
  width: 48px;
  top: 28px;
}

.loader-line-wrap:nth-child(5) .loader-line {
  border-color: #172e58;
  height: 34px;
  width: 34px;
  top: 35px;
}


/* Home.css */
.loading-enter {
  opacity: 0;
}

.loading-enter-active {
  opacity: 1;
  transition: opacity 0.5s;
}

.loading-exit {
  opacity: 1;
}

.loading-exit-active {
  opacity: 0;
  transition: opacity 0.5s;
}


@keyframes spin {
  0%,
  15% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/loading/Loading.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uEAAuE;EACvE,YAAY;EACZ,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;;AAGA,aAAa;AACb;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;;AAGA;EACE;;IAEE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".loader-inner {\n  width: 100px;\n  height: 60px;\n  margin: auto;\n  position: absolute;\n  inset: 0;\n}\n.loader{\n  height: 250px;\n  position: relative;\n}\n\n.loader-line-wrap {\n  animation: spin 2000ms cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;\n  width: 100px;\n  height: 3.5rem;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  transform-origin: 50% 100%;\n}\n\n.loader-line {\n  border: 4px solid transparent;\n  border-radius: 100%;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto;\n  position: absolute;\n  inset: 0;\n}\n\n.loader-line-wrap:nth-child(1) {\n  animation-delay: -50ms;\n}\n\n.loader-line-wrap:nth-child(2) {\n  animation-delay: -100ms;\n}\n\n.loader-line-wrap:nth-child(3) {\n  animation-delay: -150ms;\n}\n\n.loader-line-wrap:nth-child(4) {\n  animation-delay: -200ms;\n}\n\n.loader-line-wrap:nth-child(5) {\n  animation-delay: -250ms;\n}\n\n.loader-line-wrap:nth-child(1) .loader-line {\n  border-color: #fed700;\n  height: 90px;\n  width: 90px;\n  top: 7px;\n}\n\n.loader-line-wrap:nth-child(2) .loader-line {\n  border-color: #fe7e00;\n  height: 76px;\n  width: 76px;\n  top: 14px;\n}\n\n.loader-line-wrap:nth-child(3) .loader-line {\n  border-color: #dc3731;\n  height: 62px;\n  width: 62px;\n  top: 21px;\n}\n\n.loader-line-wrap:nth-child(4) .loader-line {\n  border-color: #01d1a0;\n  height: 48px;\n  width: 48px;\n  top: 28px;\n}\n\n.loader-line-wrap:nth-child(5) .loader-line {\n  border-color: #172e58;\n  height: 34px;\n  width: 34px;\n  top: 35px;\n}\n\n\n/* Home.css */\n.loading-enter {\n  opacity: 0;\n}\n\n.loading-enter-active {\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n\n.loading-exit {\n  opacity: 1;\n}\n\n.loading-exit-active {\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n\n\n@keyframes spin {\n  0%,\n  15% {\n    transform: rotate(0);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
